<div class="config-field" [class.full-span]="isFullSpan">
  <ng-container [ngSwitch]="frontendType">
    <mat-form-field *ngSwitchCase="'TEXT'" appearance="outline" class="config-field-control">
      <mat-label>{{ config.description || config.key }}</mat-label>
      <textarea
        matInput
        rows="4"
        [ngModel]="currentValue"
        (ngModelChange)="onTextChange($event)"></textarea>
      <mat-hint>{{ config.key }}</mat-hint>
    </mat-form-field>

    <mat-form-field *ngSwitchCase="'NUMBER'" appearance="outline" class="config-field-control">
      <mat-label>{{ config.description || config.key }}</mat-label>
      <input
        matInput
        type="number"
        [min]="min"
        [max]="max"
        [ngModel]="currentValue"
        (ngModelChange)="onNumberChange($event)">
      <mat-hint>{{ config.key }}</mat-hint>
    </mat-form-field>

    <mat-form-field *ngSwitchCase="'SELECT'" appearance="outline" class="config-field-control">
      <mat-label>{{ config.description || config.key }}</mat-label>
      <mat-select [ngModel]="currentValue" (ngModelChange)="onSelectChange($event)">
        <mat-option *ngFor="let option of options" [value]="option">
          {{ option }}
        </mat-option>
      </mat-select>
      <mat-hint>{{ config.key }}</mat-hint>
    </mat-form-field>

    <mat-form-field *ngSwitchCase="'DATE'" appearance="outline" class="config-field-control">
      <mat-label>{{ config.description || config.key }}</mat-label>
      <input
        matInput
        type="date"
        [ngModel]="currentValue"
        (ngModelChange)="onDateChange($event)">
      <mat-hint>{{ config.key }}</mat-hint>
    </mat-form-field>

    <mat-form-field *ngSwitchCase="'DATETIME'" appearance="outline" class="config-field-control">
      <mat-label>{{ config.description || config.key }}</mat-label>
      <input
        matInput
        type="datetime-local"
        [ngModel]="currentValue"
        (ngModelChange)="onDatetimeChange($event)">
      <mat-hint>{{ config.key }}</mat-hint>
    </mat-form-field>

    <div *ngSwitchCase="'FILE'" class="config-file-control">
      <label class="config-file-label">{{ config.description || config.key }}</label>
      <input
        type="file"
        [attr.accept]="acceptTypes"
        (change)="onFileSelected($event)">
      <div *ngIf="imagePreviewSrc" class="config-file-preview">
        <img [src]="imagePreviewSrc" alt="Preview">
      </div>
      <div class="config-file-meta">
        <span>{{ fileName || 'Ningun archivo seleccionado' }}</span>
        <small>{{ config.key }}</small>
      </div>
    </div>
  </ng-container>
</div>
